import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";
import "../sidebar/nav.css";

const Navbar = () => {
  const location = useLocation();
  const { user } = useStateContext();
  const navigate = useNavigate();
  const [pathArray, setPathArray] = useState(location.pathname.split("/"));

  useEffect(() => {
    setPathArray(location.pathname.split("/"));
  }, [location.pathname]);

  const goBack = () => {
    navigate(-1);
  };

  const formatSegment = (segment) => {
    if (!segment) return "Home";
    return segment
      .replace(/-/g, " ")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const displayName = user?.name || "Admin";
  const currentTitle =
    pathArray.length > 1
      ? formatSegment(pathArray[pathArray.length - 1])
      : "Dashboard";

  return (
    <nav className="navbar navbar-main modern-navbar navbar-expand position-sticky top-0 px-0 border-radius-xl z-index-sticky" id="navbarBlur" data-scroll="true">
      <div className="container-fluid px-3 py-2">
        <div className="breadcrumb-shell">
          <ol className="breadcrumb bg-transparent mb-0 px-0">
            <li className="breadcrumb-item">
              <span className="breadcrumb-pill">
                <i className="material-icons" style={{ fontSize: "14px" }}>
                  dashboard
                </i>
                Dashboard
              </span>
            </li>
            {pathArray.slice(1, -1).map((path, index) => (
              <li className="breadcrumb-item text-sm" key={`${path}-${index}`}>
                <span>{formatSegment(path)}</span>
              </li>
            ))}
          </ol>
          <h6 className="navbar-title" aria-current="page">
            {currentTitle}
          </h6>
        </div>

        <div className="navbar-actions" id="navbar">
          <button className="back-btn" onClick={goBack} type="button">
            <i className="material-icons">arrow_back</i>
            <span>Back</span>
          </button>

          <div className="user-pill">
            <div className="user-pill__avatar">{displayName.charAt(0).toUpperCase()}</div>
            <div className="user-pill__details">
              <span className="user-pill__name">{displayName}</span>
              <span className="user-pill__role">Admin dashboard</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
